<script>
export default {
  methods: {
    formatTohtml(string) {
      const htmlString = string
        .replace("\n", "<br />")
        .replace(/\/\/([^/]+)\/\//g, "<span>$1</span>")
        .replace(/\*([^*]+)\*/g, "<strong>$1</strong>");
      return htmlString;
    }
  }
};
</script>
